export enum SpinnerMode {
  ON = 'ON',
  OFF = 'OFF',
}
